import { render, staticRenderFns } from "./cModalViewStock.vue?vue&type=template&id=01bfd456&scoped=true"
import script from "./cModalViewStock.vue?vue&type=script&lang=js"
export * from "./cModalViewStock.vue?vue&type=script&lang=js"
import style0 from "./cModalViewStock.vue?vue&type=style&index=0&id=01bfd456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01bfd456",
  null
  
)

export default component.exports